import classNames from "classnames";
import { createElement, forwardRef, HTMLProps } from "react";

const THEMES = {
  primary: "btn-primary",
  default: "btn-default",
  danger: "btn-danger",
  small: "btn-depth btn-small",

  // Button style used throughout onboarding
  onboarding: "btn-onboarding",
};

type BaseProps = HTMLProps<HTMLButtonElement> & HTMLProps<HTMLAnchorElement>;

interface ButtonProps extends BaseProps {
  loading?: string | false;
  iconOnly?: boolean;
  theme?: keyof typeof THEMES;
  type?: "button" | "submit" | "reset";
}

const Button = forwardRef<HTMLAnchorElement | HTMLButtonElement, ButtonProps>(
  (
    {
      theme = "default",
      loading = false,
      iconOnly = false,
      className = "",
      children,
      ...props
    }: ButtonProps,
    ref,
  ) => {
    const as = props.href ? "a" : "button";

    return createElement(as, {
      ref: ref,
      ...props,
      className: classNames(
        "btn whitespace-nowrap inline-flex justify-center items-center",
        className,
        THEMES[theme],
        {
          "-icon-only": iconOnly,
          "btn--disabled": !!loading || props.disabled,
        },
      ),
      children: loading ? <span>{loading}</span> : children,
    });
  },
);

Button.displayName = "Button";

export default Button;
